<template lang="pug">
.v-field-select.field-select(:class="{'field-select--open': open, 'field-select--sm': field.size === 'sm'}")
	label.field-select__label(v-if="field.label" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	button.field-select__btn(type="button" @click="open = !open" :id="uniqueId" :disabled="field.disabled")
		span.field-select__btn-text(v-if="localValue && localValue.length" key="text") {{computedText}}
		span.field-select__btn-placeholder(v-else="" key="placeholder") {{field.placeholder}}
		v-svg-icon.field-select__btn-arrow(:icon="'chevron-down-sm'")
	.field-select__list.scrollbar(:class="field?.className")
		.field-select__list-container
			template(v-for="(option, index) in field.options")
				label.field-select__list-item.field-select__list-item--flex(:for="uniqueId2 + index" :class="option?.className")
					input.field-select__input(
							type="checkbox"
							:id="uniqueId2 + index"
							:value="option.value"
							v-model="localValue"
							@change="handleInput"
							:disabled="field.disabled || option.disabled")
					.field-checkbox__visual
					span.field-checkbox__text {{option.text}}
			button.btn.btn--primary.field-select__mobile-apply(
				v-if="field.mobileApplyText && isSm"
				type="button"
				@click.stop="open = false") {{ field.mobileApplyText }}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [isMobMixin],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Array, Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: [],
			open: false,
			uniqueId: uniqueId('field-multi-select'),
			uniqueId2: uniqueId('field-multi-select-checkbox')
		};
	},

	computed: {
		computedText() {
			let resultArr = [];
			for (let i = 0; i < this.localValue.length; i++) {
				for (let n = 0; n < this.field.options.length; n++) {
					if (this.field.options[n].value === this.localValue[i]) {
						resultArr.push(this.field.options[n].text);
					}
				}
			}
			if(resultArr.length > 3) {
				return `${this.field.test || 'Выбрано'} ${resultArr.length}` ;
			}
			return resultArr.join(', ');
		},

		activeOption() {
			if (this.field && this.field.options && this.field.options.length) {
				return this.field.options.find(option => option.value === this.localValue);
			}
			return null;
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		reset() {
			this.localValue = [];
			this.handleInput();
		},

		resetField() {
			this.localValue = [];
			this.handleInput();
			//this.open = false;
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		}
	}
};
</script>
